.control {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.select {
  position: relative;
  display: inline-block;
}

.trigger {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: var(--white);
  border: 1px solid var(--gray-border);
  border-radius: var(--radius);
  padding: 5px 10px;
  font-size: 12px;
  font-weight: 400;
  color: var(--text);
  cursor: pointer;
  white-space: nowrap;
}

.trigger:hover {
  border-color: var(--text);
}

.dot {
  /* Fixed-width box: status emoji (🟢🟡🔴🟠) have different glyph advances, so
     center each in a constant column to keep the run text left-aligned across rows. */
  display: inline-flex;
  justify-content: center;
  flex: 0 0 auto;
  width: 16px;
  font-size: 11px;
  line-height: 1;
}

.when {
  color: var(--text);
}

.chevron {
  color: var(--gray-text);
  font-size: 10px;
}

.counts {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-variant-numeric: tabular-nums;
  font-weight: 500;
}

.countPass {
  color: var(--green);
}

.countWarn {
  color: var(--yellow);
}

.countFail {
  color: var(--red);
}

.postedMarker {
  font-size: 11px;
  line-height: 1;
  opacity: 0.8;
  cursor: default;
}

/* Floating popover — absolutely positioned so it never grows the page. */
.popover {
  position: absolute;
  top: calc(100% + 4px);
  right: 0;
  z-index: 50;
  min-width: 100%;
  max-height: 320px;
  overflow-y: auto;
  background: var(--white);
  border: 1px solid var(--gray-border);
  border-radius: var(--radius);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
  padding: 4px;
  display: flex;
  flex-direction: column;
  /* Left-anchor every row so all status dots form a single left column, even when a
     posted row (with the 📌 marker) is wider than the rest. */
  align-items: flex-start;
  gap: 2px;
}

.popoverLabel {
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--gray-text);
  padding: 6px 8px 4px;
}

.option {
  display: flex;
  align-items: center;
  gap: 8px;
  background: none;
  border: none;
  border-radius: var(--radius);
  padding: 6px 8px;
  font-size: 12px;
  text-align: left;
  color: var(--text);
  cursor: pointer;
  white-space: nowrap;
}

.option:hover {
  background: var(--gray-bg);
}

.optionCurrent {
  background: var(--gray-bg);
  box-shadow: inset 2px 0 0 var(--blue-light);
}

.copyButton {
  background: none;
  border: 1px solid var(--gray-border);
  border-radius: var(--radius);
  padding: 5px 9px;
  font-size: 12px;
  color: var(--gray-text);
  cursor: pointer;
  white-space: nowrap;
}

.copyButton:hover {
  border-color: var(--text);
  color: var(--text);
}
